import { render, staticRenderFns } from "./EditObjective.vue?vue&type=template&id=72ad2622&scoped=true&"
import script from "./EditObjective.vue?vue&type=script&lang=js&"
export * from "./EditObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad2622",
  null
  
)

export default component.exports